import { externalLink } from 'icons/externalLink';

import { setCustomTagHTML } from 'helpers/helpers';
import { ENGT_CHAT } from 'js/bot.model';

import { BOT_MODE } from 'consts/enum';

import { addClass, removeClass } from '../../helpers/helpers';
import { SourcePreviewHeader } from '../header/types/sourcePreviewHeader/sourcePreviewHeader.module';
import { SourseViewerTemplate } from './sourceViewer.template';

export default class SourceViewer {
	constructor() {
		this.init();
	}

	init(props = { sourceLink: '' }) {
		this.initData(props);
		this.initWrapper();
		this.initComponents();
		this.initEvents();
	}

	initData(props) {
		this.data = {
			...props,
		};
	}

	initWrapper() {
		const wrapper = document.createElement('div');
		wrapper.classList.add('engt-source-preview');
		wrapper.id = 'engtSourcePreview';
		wrapper.setAttribute('tabindex', '-1');
		wrapper.innerHTML = SourseViewerTemplate();

		this.html = wrapper;
	}

	initComponents() {
		const header = new SourcePreviewHeader().render();

		const body = document.createElement('div');
		body.classList.add('engt-source-preview-body');
		body.id = 'engtSourceViewerBody';

		const sourceLink = this.data.sourceLink || '';

		if (sourceLink) {
			const separator = sourceLink.includes('?') ? '&' : '?';
			const iframeSrc = `${sourceLink}${separator}isWebLinkPreviewEnabled=true`;

			const iframe = document.createElement('iframe');
			iframe.id = 'documentViewer';
			iframe.src = iframeSrc;
			iframe.style.width = '100%';
			iframe.style.height = '100%';
			iframe.style.border = 'none';

			body.appendChild(iframe);
		}

		const footer = `<div class="engt-powered">
		    <div class="engt-powered-text">
			<a href=${this.data.sourceLink} target="_blank" class="poweredByLink">
				<span class="engt-external-link">${externalLink()}</span><span class="engt-external-link-text">Open in new tab</span></a></div>
			</div>`;

		setCustomTagHTML(this.html.querySelector('source-viewer-header'), header);
		setCustomTagHTML(this.html.querySelector('source-viewer-body'), body);
		setCustomTagHTML(this.html.querySelector('source-viewer-footer'), footer);
	}

	initEvents() {
		ENGT_CHAT.set('showSourcePreviewScreen', this.showSourcePreviewScreen.bind(this));
		ENGT_CHAT.set('hideSourcePreviewScreen', this.hideSourcePreviewScreen.bind(this));
		ENGT_CHAT.set('reRenderSourcePreview', this.reRenderSourcePreview.bind(this));
	}

	showSourcePreviewScreen(url = '') {
		if (!url) return;
		this.reRenderSourcePreview({ sourceLink: url });
	}

	hideSourcePreviewScreen() {
		addClass(this.html, 'engt-source-preview-hidden');
		document.querySelector('.engt-pages').style.display = null;
		setTimeout(
			() => {
				removeClass(this.html, 'engt-source-preview-visible');
				ENGT_CHAT.get('reRenderChatScreen')();
				document.getElementById('engtSourcePreview').setAttribute('tabindex', -1);
			},
			ENGT_CHAT.get('config.bot_mode') === BOT_MODE.STANDALONE ? 0 : 600
		);
	}

	reRenderSourcePreview(url) {
		const wrapper = document.getElementById('engtSourcePreview');
		this.init(url);
		removeClass(this.html, 'engt-source-preview-hidden');
		addClass(this.html, 'engt-source-preview-visible');
		ENGT_CHAT.get('reRenderChatScreen')();
		document.querySelector('.engt-pages').style.display = 'none';
		wrapper.parentNode.replaceChild(this.html, wrapper);
	}

	render() {
		return this.html;
	}
}
